export const SNIPPET_START = "<!-- m8t:a2a:start -->";
export const SNIPPET_END = "<!-- m8t:a2a:end -->";

export const DELEGATE_SNIPPET = `${SNIPPET_START}
## Working with other workers
You can delegate to other m8t workers. Before you do:
1. Call \`discover_workers\` to see who's available now — each entry's card says what
   the worker is for, when to delegate to it, and what it accepts and returns.
2. If one is a clear fit, call \`invoke_worker(target, task)\` — \`target\` is the name
   from the directory; \`task\` is a complete, self-contained instruction (the worker
   can't ask follow-ups mid-task).
3. If invoke_worker returns status "in_progress" with a taskId, the worker is taking
   a while — call \`check_delegation(taskId)\` to fetch the result, repeating until the
   status is no longer "in_progress".
4. Fold the worker's result into your own answer.
Delegate only when another worker is genuinely better suited; otherwise answer
directly. Don't re-delegate the same request in a loop.
${SNIPPET_END}`;

function esc(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/** Strip a previously-appended a2a snippet (marker-delimited) from instructions. */
export function stripSnippet(instructions: string): string {
  const re = new RegExp(`\\n*${esc(SNIPPET_START)}[\\s\\S]*?${esc(SNIPPET_END)}\\n*`, "g");
  return instructions.replace(re, "\n").replace(/\s+$/, "");
}

/** Strip any prior snippet, then append the canonical one at the end. Idempotent. */
export function appendSnippet(instructions: string): string {
  return `${stripSnippet(instructions).replace(/\s+$/, "")}\n\n${DELEGATE_SNIPPET}`;
}

/** True when instructions already carry the a2a snippet markers. */
export function hasA2aSnippet(instructions: string): boolean {
  return instructions.includes(SNIPPET_START);
}
